module.exports = __webpack_public_path__ + "img/07.b7942430.png";